import EmblaSlider from "@/app/components/lib/Embla-slider";
import { TSlideWidith } from "@/app/components/lib/Embla-slider/EmblaSliderContainer";
import { JSX } from "react";

interface Props {
  spacing: number;
  children: JSX.Element[];
}

const FileThumbmailSlider: React.FC<Props> = ({ spacing, children }) => {
  const itemWidth = 102;
  return (
    <div style={{ marginInlineEnd: -24 }}>
      <EmblaSlider>
        <EmblaSlider.EmblaSliderViewport>
          <EmblaSlider.EmblaSliderContainer
            gap={spacing}
            slides={[
              ...(children as Array<JSX.Element>)?.map((child, key) => ({
                component: (
                  <div key={key} style={{ width: itemWidth }}>
                    {child}
                  </div>
                ),
                width: "auto" as TSlideWidith,
              })),
            ]}
          />
        </EmblaSlider.EmblaSliderViewport>
      </EmblaSlider>
    </div>
  );
};

export default FileThumbmailSlider;
